export default __webpack_public_path__ + "static/media/logo-enviar-nav.03b6d139.svg";